import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Subscription, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as firebaseui from 'firebaseui';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { EmailAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import { Router } from '@angular/router';
import { MatDivider } from '@angular/material/divider';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [MatDivider],
})
export class LoginComponent implements OnDestroy, OnInit {
  authUi?: firebaseui.auth.AuthUI;

  constructor(
    private readonly afAuth: AngularFireAuth,
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {
    this.afAuth.app.then((app) => {
      const uiConfig = {
        signInOptions: [EmailAuthProvider.PROVIDER_ID, GoogleAuthProvider.PROVIDER_ID],
        callbacks: {
          signInSuccessWithAuthResult: this.onLoginSuccess.bind(this),
        },
      };

      this.authUi = new firebaseui.auth.AuthUI(app.auth());
      this.authUi.start('#firebaseui-auth-container', uiConfig);
      this.authUi.disableAutoSignIn();
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.authUi?.delete();
  }

  onLoginSuccess(result: any, redirectUrl: string | undefined) {
    this.router.navigateByUrl('');
    return false;
  }
}
